// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"2755a7bb","129":"2755a7bb","294":"2755a7bb","351":"2755a7bb","559":"2755a7bb","783":"2755a7bb","885":"2755a7bb"}[chunkId] + ".chunk.css";
};